import { useParameter } from '../../../shared';
import { useCommoditiesGroupName } from './useCommoditiesGroupName';

export function useSlideTitle() {
  const commoditiesGroupName = useCommoditiesGroupName();
  const [business] = [1]; //useParameter<number>("@business-units");
  const bname = (business || 1) === 2 ? "APE" : "AP";
  const title = `Aquarium chart: ${bname} major ${commoditiesGroupName} by lead countries - crop value`;
  return title;
}